import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import InnerContainer from '../Shared/InnerContainer';
import Card from '../Shared/Card';

var marked = require('marked');

const Teaching_Item = (props) => (
      <ClassCard>
        <ClassTitle>
          {props.class.title}
        </ClassTitle>
          <ClassInstitution>
            {props.class.institution}
          </ClassInstitution>
          <ClassSemester>
            {props.class.semester.map((sem, i) => (
              <span key={i}>
                {sem}
                {props.class.semester.length -1 > i ? ', ' : ''}
              </span>
            ))}
          </ClassSemester>
          {props.class.courseType &&
            props.class.courseType.map((c,i) => {
            return <ClassType type={c} key={i}>{c}</ClassType>
          })}
      </ClassCard>
);

export default Teaching_Item;

const ClassCard = Card.extend`
  margin: 0px 10px 20px;
  flex: 0 1 45%;
  width: 440px;
  min-height: 225px;

  @media (max-width: 900px) {
    max-width: 800px;
    flex: 0 1 100%;
    margin: 0px 0px 20px;
  }

  @media (max-width: 600px) {
    width: 100%;
    })
`;

// const ALink = styled.a`
//   text-decoration: none;
//   color: #333;
//   &:hover {
//     color: seagreen;
//   }
// `;

const ClassTitle = styled.h2`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
`;

const ClassInstitution = styled.h3`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.25rem;
  margin: 0px 0px 0.5rem;
  opacity: 0.5;
`;

const ClassSemester = styled.p`
  line-height: 1.5rem;
  margin: 0px 0px 1rem;
  font-weight: 400;
`;

const ClassType = styled.span`
  margin-right: 0.25rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  background: ${props =>
    (props.type == 'Lecture' && 'steelblue')
    || (props.type == 'Laboratory' && 'mediumpurple')
    || 'seagreen'
  };
  color: white;
`;
//
// const ProjectDescription = styled.p`
//   line-height: 1.5rem;
//   margin: 0px 0px .5rem;
//   opacity: 0.7;
// `;

// const RelavantPapers = styled.p`
//   background: linear-gradient(rgba(251, 251, 251,1),rgba(255, 255, 255,1));
//   padding: 10px 20px;
//   margin: 10px 0px;
//   color: seagreen;
//   border: 1px solid #eee;
//   border-left: 5px solid seagreen;
// `;



// WEBPACK FOOTER //
// ./src/components/Teaching_Item/index.js